import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAssetUrl } from '../../api/config';
import marsImg from '../../assets/characters/Mars.png';
import Header from "../../components/Header";
import PlanetsBackground from "../../components/PlanetsBackground";
import {AppContext} from "../../contexts/AppContext";
import '../../styles/HidingGame.css';

export default function HidingGame() {
    const navigate = useNavigate();
    const language = localStorage.getItem('selectedLanguage') || 'it';

    const [correctIndex, setCorrectIndex] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [round, setRound] = useState(1);
    const [headerColor, setHeaderColor] = useState('#64798A');

    const { enableText, enableAudio, setEnableText, setEnableAudio } = useContext(AppContext);

    // Lista dei pianeti dal nuovo componente
    const planets = [
        { color: 'red' },
        { color: 'blue' },
        { color: 'green' },
        { color: 'grey' },
        { color: 'purple' },
        { color: 'orange' },
        { color: 'brown' },
    ];

    // Funzione per generare un nuovo indice casuale
    const getNewRandomIndex = (currentIndex) => {
        let newIndex;
        do {
            newIndex = Math.floor(Math.random() * planets.length);
        } while (newIndex === currentIndex);
        return newIndex;
    };

    useEffect(() => {
        setHeaderColor('#64798A');
        setCorrectIndex(Math.floor(Math.random() * planets.length));
        
        // Audio iniziale MARS5
        if (enableAudio) {
            const introAudio = new Audio(getAssetUrl('/audios/storyline/it/mars5.wav'));
            introAudio.play().catch(console.error);
        }
    }, []);

    const handleClick = (index) => {
        setSelectedIndex(index);

        if (index === correctIndex) {
            // Audio di successo random (MARS6, 7, 8)
            if (enableAudio) {
                const successAudios = ['mars6.wav', 'mars7.wav', 'mars8.wav'];
                const randomAudio = successAudios[Math.floor(Math.random() * successAudios.length)];
                const audio = new Audio(getAssetUrl(`/audios/storyline/it/${randomAudio}`));
                audio.play().catch(console.error);
            }

            if (round < 3) {
                setTimeout(() => {
                    setRound(prev => prev + 1);
                    setSelectedIndex(null);
                    setCorrectIndex(prevIndex => getNewRandomIndex(prevIndex));
                }, 1500); // Aumentato delay per permettere all'audio di finire
            } else {
                setTimeout(() => {
                    navigate('/pages/exePage');
                }, 2000);
            }
        }
    };

    return (
        <div className="hiding-game-wrapper">
            <Header
                color={headerColor}
                enableText={enableText}
                setEnableText={setEnableText}
                enableAudio={enableAudio}
                setEnableAudio={setEnableAudio}
            />
            <div className="planet-background">
            <PlanetsBackground />

            {planets.map((planet, index) => (
                <div
                    key={planet.color}
                    className={`planet-absolute planet-${planet.color}`}
                    style={{ borderRadius: '50%' }} // Aiuta visivamente e come hit-area base
                >
                    {index === correctIndex && (
                        <img 
                            src={marsImg} 
                            alt="Mars" 
                            className="mars-side" 
                            onClick={() => handleClick(index)}
                        />
                    )}
                </div>
            ))}
            </div>
        </div>
    );
}